import { Helmet } from "react-helmet-async";

const SITE_NAME = "Eval Ninja";
const SITE_URL = "https://evalninja.app";
const DEFAULT_DESCRIPTION =
  "Eval Ninja simplifies player evaluations for youth sports clubs. Run tryouts, assign teams, and share parent reports — all from one platform.";
const OG_IMAGE = `${SITE_URL}/assets/og-image.png`;

export default function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "/",
  children,
}) {
  const pageTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} - Player Evaluations Made Easy`;
  const canonical = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />

      {children}
    </Helmet>
  );
}
